import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f4f4f4',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px 16px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  card: {
    width: '100%',
    maxWidth: 520,
    background: '#fff',
    borderRadius: 16,
    boxShadow: 'none',
    overflow: 'hidden',
  },
  header: {
    background: '#191c1f',
    padding: '24px 28px',
    textAlign: 'center',
  },
  logo: {
    display: 'block',
    width: 150,
    height: 'auto',
    margin: '0 auto 12px',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#fff',
    marginBottom: 4,
  },
  headerSub: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.5)',
  },
  body: {
    padding: '28px',
  },
  greeting: {
    fontSize: 14,
    color: '#191c1f',
    lineHeight: 1.6,
    marginBottom: 20,
  },
  sectionLabel: {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    color: '#00a87e',
    marginBottom: 12,
    marginTop: 4,
  },
  prefilledRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px',
    background: '#f4f4f4',
    borderRadius: 6,
    marginBottom: 6,
    fontSize: 13,
  },
  prefilledLabel: {
    color: '#191c1f',
    fontWeight: 500,
    fontSize: 12,
  },
  prefilledValue: {
    color: '#191c1f',
    fontSize: 12,
    textAlign: 'right',
    maxWidth: '60%',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  fieldGroup: {
    marginBottom: 16,
  },
  label: {
    display: 'block',
    fontSize: 12,
    fontWeight: 600,
    color: '#191c1f',
    marginBottom: 5,
  },
  required: {
    color: '#00a87e',
    marginLeft: 2,
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid #D6D1CA',
    borderRadius: 6,
    fontSize: 16,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#191c1f',
    background: '#fff',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
    outline: 'none',
    minHeight: 44,
    WebkitAppearance: 'none',
  },
  inputError: {
    borderColor: '#D32F2F',
  },
  textarea: {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid #D6D1CA',
    borderRadius: 6,
    fontSize: 16,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#191c1f',
    background: '#fff',
    boxSizing: 'border-box',
    resize: 'vertical',
    minHeight: 100,
    outline: 'none',
    WebkitAppearance: 'none',
  },
  errorText: {
    fontSize: 11,
    color: '#D32F2F',
    marginTop: 4,
  },
  submitBtn: {
    width: '100%',
    padding: '14px 24px',
    fontSize: 16,
    minHeight: 48,
    fontWeight: 700,
    background: '#00a87e',
    color: '#fff',
    border: 'none',
    borderRadius: 9999,
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    marginTop: 8,
    transition: 'opacity 0.2s',
  },
  submitBtnDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  divider: {
    height: 1,
    background: '#E8E4DE',
    margin: '24px 0',
  },
  statusCard: {
    textAlign: 'center',
    padding: '48px 28px',
  },
  statusIcon: {
    fontSize: 48,
    marginBottom: 16,
  },
  statusTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#191c1f',
    marginBottom: 8,
  },
  statusText: {
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 1.6,
  },
  footer: {
    textAlign: 'center',
    padding: '20px 28px',
    borderTop: '1px solid #E8E4DE',
    fontSize: 11,
    color: '#9CA3AF',
  },
};

function FormField({ label, required, type, value, onChange, placeholder, error, maxLength, style: extraStyle }) {
  return (
    <div style={styles.fieldGroup}>
      <label style={styles.label}>
        {label}{required && <span style={styles.required}>*</span>}
      </label>
      <input
        type={type || 'text'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        style={{ ...styles.input, ...(error ? styles.inputError : {}), ...extraStyle }}
      />
      {error && <div style={styles.errorText}>{error}</div>}
    </div>
  );
}

export default function TenantForm() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [formStatus, setFormStatus] = useState(null);
  const [prefilled, setPrefilled] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [serverError, setServerError] = useState(null);

  // Mieter 1
  const [emailMieter1, setEmailMieter1] = useState('');
  const [telefonMieter1, setTelefonMieter1] = useState('');
  const [notfallNameMieter1, setNotfallNameMieter1] = useState('');
  const [notfallTelefonMieter1, setNotfallTelefonMieter1] = useState('');
  const [ibanMieter1, setIbanMieter1] = useState('');
  const [bicMieter1, setBicMieter1] = useState('');
  const [kontoinhaberMieter1, setKontoinhaberMieter1] = useState('');

  // Mieter 2
  const [emailMieter2, setEmailMieter2] = useState('');
  const [telefonMieter2, setTelefonMieter2] = useState('');
  const [ibanMieter2, setIbanMieter2] = useState('');
  const [bicMieter2, setBicMieter2] = useState('');
  const [kontoinhaberMieter2, setKontoinhaberMieter2] = useState('');

  // Allgemein
  const [nameKlingelschild, setNameKlingelschild] = useState('');
  const [anmerkungen, setAnmerkungen] = useState('');
  const [errors, setErrors] = useState({});

  const hasMieter2 = !!(prefilled.mieter2_name && prefilled.mieter2_name.trim());

  useEffect(() => {
    fetch(`${API_URL}/tenant-form/public/${token}`)
      .then(r => {
        if (r.status === 404) throw new Error('not_found');
        return r.json();
      })
      .then(data => {
        setFormStatus(data.status);
        if (data.prefilled_data) {
          setPrefilled(data.prefilled_data);
          if (data.prefilled_data.mieter_name) {
            setNameKlingelschild(data.prefilled_data.mieter_name);
          }
        }
        setLoading(false);
      })
      .catch(err => {
        setFormStatus('error');
        setServerError(err.message === 'not_found' ? 'Formular nicht gefunden.' : 'Verbindungsfehler.');
        setLoading(false);
      });
  }, [token]);

  const validateIban = (iban) => {
    if (!iban.trim()) return null;
    const clean = iban.trim().replace(/\s/g, '');
    if (!clean.startsWith('DE')) return 'IBAN muss mit DE beginnen';
    if (clean.length !== 22) return 'Deutsche IBAN muss 22 Zeichen haben';
    if (!/^[A-Za-z0-9]+$/.test(clean)) return 'IBAN darf nur Buchstaben und Zahlen enthalten';
    return null;
  };

  const validate = () => {
    const errs = {};
    // Mieter 1
    if (!emailMieter1.trim()) errs.emailMieter1 = 'E-Mail-Adresse ist erforderlich';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailMieter1.trim())) errs.emailMieter1 = 'Ungültige E-Mail-Adresse';
    if (!telefonMieter1.trim()) errs.telefonMieter1 = 'Telefonnummer ist erforderlich';
    if (!notfallNameMieter1.trim()) errs.notfallNameMieter1 = 'Notfallkontakt Name ist erforderlich';
    if (!notfallTelefonMieter1.trim()) errs.notfallTelefonMieter1 = 'Notfallkontakt Telefon ist erforderlich';
    if (!nameKlingelschild.trim()) errs.nameKlingelschild = 'Name Klingelschild ist erforderlich';

    const ibanErr1 = validateIban(ibanMieter1);
    if (ibanErr1) errs.ibanMieter1 = ibanErr1;

    // Mieter 2
    if (hasMieter2) {
      if (!emailMieter2.trim()) errs.emailMieter2 = 'E-Mail-Adresse ist erforderlich';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailMieter2.trim())) errs.emailMieter2 = 'Ungültige E-Mail-Adresse';
      if (!telefonMieter2.trim()) errs.telefonMieter2 = 'Telefonnummer ist erforderlich';
    }
    const ibanErr2 = validateIban(ibanMieter2);
    if (ibanErr2) errs.ibanMieter2 = ibanErr2;

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    setServerError(null);

    try {
      const res = await fetch(`${API_URL}/tenant-form/public/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email_mieter1: emailMieter1.trim(),
          telefon_mieter1: telefonMieter1.trim(),
          notfallkontakt_name_mieter1: notfallNameMieter1.trim(),
          notfallkontakt_telefon_mieter1: notfallTelefonMieter1.trim(),
          name_klingelschild: nameKlingelschild.trim(),
          iban_mieter1: ibanMieter1.trim().replace(/\s/g, '') || null,
          bic_mieter1: bicMieter1.trim() || null,
          kontoinhaber_mieter1: kontoinhaberMieter1.trim() || null,
          anmerkungen: anmerkungen.trim() || null,
          email_mieter2: emailMieter2.trim() || null,
          telefon_mieter2: telefonMieter2.trim() || null,
          iban_mieter2: ibanMieter2.trim().replace(/\s/g, '') || null,
          bic_mieter2: bicMieter2.trim() || null,
          kontoinhaber_mieter2: kontoinhaberMieter2.trim() || null,
        }),
      });

      if (res.ok) {
        setSubmitted(true);
      } else {
        const data = await res.json();
        setServerError(data.detail || 'Fehler beim Absenden');
      }
    } catch (err) {
      setServerError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
    }
    setSubmitting(false);
  };

  const clearError = (key) => setErrors(p => ({ ...p, [key]: undefined }));

  // Loading
  if (loading) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.header}>
            <img src="/assets/logos/one-immo-lockup-on-dark.svg" alt="One. immo" style={styles.logo} />
            <div style={styles.headerTitle}>One. immo</div>
          </div>
          <div style={{ ...styles.statusCard, padding: '60px 28px' }}>
            <div style={{ fontSize: 14, color: '#6B7280' }}>Formular wird geladen...</div>
          </div>
        </div>
      </div>
    );
  }

  // Expired
  if (formStatus === 'expired') {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.header}>
            <img src="/assets/logos/one-immo-lockup-on-dark.svg" alt="One. immo" style={styles.logo} />
            <div style={styles.headerTitle}>One. immo</div>
          </div>
          <div style={styles.statusCard}>
            <div style={styles.statusTitle}>Link abgelaufen</div>
            <div style={styles.statusText}>
              Dieser Link ist leider abgelaufen.<br />
              Bitte wenden Sie sich an Ihren Ansprechpartner bei One. immo.
            </div>
          </div>
          <div style={styles.footer}>One Dot Immo GmbH</div>
        </div>
      </div>
    );
  }

  // Already submitted
  if (formStatus === 'submitted' || submitted) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.header}>
            <img src="/assets/logos/one-immo-lockup-on-dark.svg" alt="One. immo" style={styles.logo} />
            <div style={styles.headerTitle}>One. immo</div>
          </div>
          <div style={styles.statusCard}>
            <div style={{ ...styles.statusIcon, color: '#16A34A' }}>&#10003;</div>
            <div style={styles.statusTitle}>Vielen Dank!</div>
            <div style={styles.statusText}>
              Ihre Daten wurden erfolgreich übermittelt.<br />
              Wir melden uns in Kürze mit weiteren Informationen zu Ihrem Mietvertrag.
            </div>
          </div>
          <div style={styles.footer}>One Dot Immo GmbH</div>
        </div>
      </div>
    );
  }

  // Error
  if (formStatus === 'error') {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.header}>
            <img src="/assets/logos/one-immo-lockup-on-dark.svg" alt="One. immo" style={styles.logo} />
            <div style={styles.headerTitle}>One. immo</div>
          </div>
          <div style={styles.statusCard}>
            <div style={styles.statusTitle}>Fehler</div>
            <div style={styles.statusText}>{serverError || 'Ein Fehler ist aufgetreten.'}</div>
          </div>
          <div style={styles.footer}>One Dot Immo GmbH</div>
        </div>
      </div>
    );
  }

  // Form
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img src="/assets/logos/one-immo-lockup-on-dark.svg" alt="One. immo" style={styles.logo} />
          <div style={styles.headerTitle}>Mieterdaten-Formular</div>
          <div style={styles.headerSub}>One Dot Immo GmbH</div>
        </div>

        <div style={styles.body}>
          {/* Begrüßung */}
          {prefilled.mieter_name && (
            <div style={styles.greeting}>
              Sehr geehrte/r {prefilled.mieter_name},<br />
              bitte ergänzen Sie folgende Angaben für Ihren Mietvertrag
              {prefilled.objektanschrift ? ` in der ${prefilled.objektanschrift}` : ''}.
            </div>
          )}

          {/* Vorbefüllte Daten */}
          <div style={styles.sectionLabel}>Ihre Vertragsdaten</div>
          {prefilled.mieter_name && (
            <div style={styles.prefilledRow}>
              <span style={styles.prefilledLabel}>Mieter</span>
              <span style={styles.prefilledValue}>{prefilled.mieter_name}</span>
            </div>
          )}
          {hasMieter2 && (
            <div style={styles.prefilledRow}>
              <span style={styles.prefilledLabel}>Mieter 2</span>
              <span style={styles.prefilledValue}>{prefilled.mieter2_name}</span>
            </div>
          )}
          {prefilled.mieter_anschrift && (
            <div style={styles.prefilledRow}>
              <span style={styles.prefilledLabel}>Aktuelle Anschrift</span>
              <span style={styles.prefilledValue}>{prefilled.mieter_anschrift}</span>
            </div>
          )}
          {prefilled.objektanschrift && (
            <div style={styles.prefilledRow}>
              <span style={styles.prefilledLabel}>Mietobjekt</span>
              <span style={styles.prefilledValue}>{prefilled.objektanschrift}</span>
            </div>
          )}
          {prefilled.mietbeginn && (
            <div style={styles.prefilledRow}>
              <span style={styles.prefilledLabel}>Mietbeginn</span>
              <span style={styles.prefilledValue}>{prefilled.mietbeginn}</span>
            </div>
          )}

          <div style={styles.divider} />

          {serverError && (
            <div style={{
              padding: '10px 14px', marginBottom: 16, borderRadius: 6,
              background: '#FEF2F2', border: '1px solid #FECACA',
              fontSize: 12, color: '#D32F2F',
            }}>
              {serverError}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* ── Mieter 1 ── */}
            <div style={styles.sectionLabel}>
              Mieter 1 {prefilled.mieter_name ? `- ${prefilled.mieter_name}` : ''}
            </div>

            <FormField label="E-Mail-Adresse" required type="email" value={emailMieter1}
              onChange={e => { setEmailMieter1(e.target.value); clearError('emailMieter1'); }}
              placeholder="ihre.email@beispiel.de" error={errors.emailMieter1} />

            <FormField label="Telefon" required type="tel" value={telefonMieter1}
              onChange={e => { setTelefonMieter1(e.target.value); clearError('telefonMieter1'); }}
              placeholder="+49 170 1234567" error={errors.telefonMieter1} />

            <FormField label="Notfallkontakt Name" required value={notfallNameMieter1}
              onChange={e => { setNotfallNameMieter1(e.target.value); clearError('notfallNameMieter1'); }}
              placeholder="Name des Notfallkontakts" error={errors.notfallNameMieter1} />

            <FormField label="Notfallkontakt Telefon" required type="tel" value={notfallTelefonMieter1}
              onChange={e => { setNotfallTelefonMieter1(e.target.value); clearError('notfallTelefonMieter1'); }}
              placeholder="+49 170 1234567" error={errors.notfallTelefonMieter1} />

            <div style={{ fontSize: 13, fontWeight: 600, color: '#6B6860', marginTop: 16, marginBottom: 8 }}>Bankverbindung (SEPA-Lastschrift)</div>
            <FormField label="IBAN" value={ibanMieter1}
              onChange={e => { setIbanMieter1(e.target.value.toUpperCase()); clearError('ibanMieter1'); }}
              placeholder="DE..." maxLength={27} error={errors.ibanMieter1}
              style={{ fontFamily: 'monospace' }} />
            <FormField label="Kontoinhaber" value={kontoinhaberMieter1}
              onChange={e => setKontoinhaberMieter1(e.target.value)}
              placeholder="Vor- und Nachname" />
            <FormField label="BIC" value={bicMieter1}
              onChange={e => setBicMieter1(e.target.value.toUpperCase())}
              placeholder="z.B. COBADEFFXXX" maxLength={11}
              style={{ fontFamily: 'monospace' }} />

            {/* ── Mieter 2 ── */}
            {hasMieter2 && (<>
              <div style={styles.divider} />
              <div style={styles.sectionLabel}>
                Mieter 2 {prefilled.mieter2_name ? `- ${prefilled.mieter2_name}` : ''}
              </div>

              <FormField label="E-Mail-Adresse" required type="email" value={emailMieter2}
                onChange={e => { setEmailMieter2(e.target.value); clearError('emailMieter2'); }}
                placeholder="email.mieter2@beispiel.de" error={errors.emailMieter2} />

              <FormField label="Telefon" required type="tel" value={telefonMieter2}
                onChange={e => { setTelefonMieter2(e.target.value); clearError('telefonMieter2'); }}
                placeholder="+49 170 1234567" error={errors.telefonMieter2} />

              <div style={{ fontSize: 13, fontWeight: 600, color: '#6B6860', marginTop: 12, marginBottom: 8 }}>Bankverbindung Mieter 2</div>
              <FormField label="IBAN" value={ibanMieter2}
                onChange={e => { setIbanMieter2(e.target.value.toUpperCase()); clearError('ibanMieter2'); }}
                placeholder="DE..." maxLength={27} error={errors.ibanMieter2}
                style={{ fontFamily: 'monospace' }} />
              <FormField label="Kontoinhaber" value={kontoinhaberMieter2}
                onChange={e => setKontoinhaberMieter2(e.target.value)}
                placeholder="Vor- und Nachname" />
              <FormField label="BIC" value={bicMieter2}
                onChange={e => setBicMieter2(e.target.value.toUpperCase())}
                placeholder="z.B. COBADEFFXXX" maxLength={11}
                style={{ fontFamily: 'monospace' }} />
            </>)}

            {/* ── Allgemein ── */}
            <div style={styles.divider} />
            <div style={styles.sectionLabel}>Allgemein</div>

            <FormField label="Name auf dem Klingelschild" required value={nameKlingelschild}
              onChange={e => { setNameKlingelschild(e.target.value); clearError('nameKlingelschild'); }}
              placeholder="Name auf dem Klingelschild" error={errors.nameKlingelschild} />

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Anmerkungen</label>
              <textarea
                value={anmerkungen}
                onChange={e => setAnmerkungen(e.target.value)}
                placeholder="Haben Sie besondere Wünsche oder Hinweise?"
                style={styles.textarea}
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              style={{ ...styles.submitBtn, ...(submitting ? styles.submitBtnDisabled : {}) }}
            >
              {submitting ? 'Wird gesendet...' : 'Daten absenden'}
            </button>
          </form>
        </div>

        <div style={styles.footer}>
          One Dot Immo GmbH &middot; Ihre Daten werden vertraulich behandelt.
        </div>
      </div>
    </div>
  );
}
